import React, { useState } from "react";
import { Button, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Input, Stack } from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import formatHoursAndMinutes from "../lib/helpers/formatHoursAndMinutes";
import { CopySimple, PencilSimple } from "@phosphor-icons/react";

export default function TaskTable({ userTasks, onDeleteTask, onMarkAsCompleted, onDuplicateTask, onEditTask }) {
  const [editTaskId, setEditTaskId] = useState(null);
  const [editedTimeSpent, setEditedTimeSpent] = useState("");

  const handleEditTask = (taskId, timeSpent) => {
    setEditTaskId(taskId);
    setEditedTimeSpent(formatHoursAndMinutes(Math.floor(timeSpent / 60), Math.round(timeSpent % 60)));
  };

  const handleTimeChange = e => {
    setEditedTimeSpent(e.target.value);
  };

  const handleSaveTask = taskId => {
    const [hours, minutes] = editedTimeSpent.split(":").map(Number);
    const updatedTimeSpent = hours * 60 + minutes;
    onEditTask(taskId, updatedTimeSpent);
    setEditTaskId(null);
  };

  return (
    <TableContainer width="full" maxWidth={"100%"} px={"6"}>
      <Table variant="simple" fontSize={{ base: "sm", md: "md" }}>
        <Thead width={"full"}>
          <Tr width={"full"}>
            <Th display={{ base: "none", md: "table-cell" }}>Client : </Th>
            <Th>Section : </Th>
            <Th>Temps : </Th>
            {onDeleteTask && onMarkAsCompleted ? <Th>Action : </Th> : null}
          </Tr>
        </Thead>
        <Tbody>
          {userTasks.map(task => (
            <Tr key={task.id} width={"full"}>
              <Td display={{ base: "none", md: "table-cell" }}>{task.client_name} <i style={{fontSize: "12px"}}>({task.portfolio_name??''})</i> / {task.nom}</Td>
              <Td>{task.task_code} : {task.task_description !== null ? task.task_name + " : " + task.task_description : task.task_name}</Td>
              <Td>
                {editTaskId === task.id ? (
                  <Input
                    type="time"
                    value={editedTimeSpent}
                    onChange={handleTimeChange}
                    step="60" // step set to 1 minute intervals
                  />
                ) : (
                  formatHoursAndMinutes(Math.floor(task.time_spent / 60), Math.round(task.time_spent % 60))
                )}
              </Td>
                <Td>
                  <Stack direction={{ base: "column", md: "row" }} spacing={2} width="100%">
                    {onDeleteTask ? (
                      <Button
                        _hover={({ color: "black" }, { backgroundColor: "red.500" })}
                        backgroundColor={"#D60620"}
                        color={"white"}
                        leftIcon={<DeleteIcon />}
                        variant={"outline"}
                        onClick={() => onDeleteTask(task.id)}
                      >
                        Supprimer
                      </Button>
                    ) : null}
                    {onMarkAsCompleted ? (
                      <Button
                        _hover={({ color: "black" }, { backgroundColor: "lightgoldenrodyellow" })}
                        backgroundColor={"lightgoldenrodyellow"}
                        onClick={() => onMarkAsCompleted(task.id)}
                      >
                        Terminer cette tâche
                      </Button>
                    ) : null}
                    {onDuplicateTask ? (
                      <Button _hover={({ color: "black" }, { backgroundColor: "lightGrey" })} backgroundColor={"transparent"} onClick={() => onDuplicateTask(task.id)}>
                        <CopySimple size={20} />
                      </Button>
                    ) : null}
                    {editTaskId === task.id ? (
                      <Button
                        _hover={({ color: "black" }, { backgroundColor: "lightGrey" })}
                        variant={"outline"}
                        backgroundColor={"lightgreen"}
                        onClick={() => handleSaveTask(task.id)}
                      >
                        Enregistrer
                      </Button>
                    ) : (
                      <Button
                        _hover={({ color: "black" }, { backgroundColor: "lightGrey" })}
                        backgroundColor={"transparent"}
                        onClick={() => handleEditTask(task.id, task.time_spent)}
                      >
                        <PencilSimple size={20} />
                      </Button>
                    )}
                  </Stack>
                </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
